module.exports = __webpack_public_path__ + "img/Pitch-View-Club-Seats.9a51d04e.jpg";